module.exports = __webpack_public_path__ + "img/outair.e5bfd15b.png";